import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Button, 
  Box, 
  Paper,
  CircularProgress
} from '@mui/material';
import DeleteUser from '../components/DeleteUser';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';

const DeleteUserPage = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simular carga de datos
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" my={8}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography variant="h4" gutterBottom>
              {language === 'es' ? 'Administración de Usuarios' : 'User Management'}
            </Typography>
            <Typography variant="body1" paragraph>
              {language === 'es' 
                ? 'Esta página permite eliminar el usuario específico abalarezoc@hotmail.com del sistema.' 
                : 'This page allows you to delete the specific user abalarezoc@hotmail.com from the system.'}
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontWeight: 'bold', color: 'error.main' }}>
              {language === 'es' 
                ? 'Advertencia: Esta acción no se puede deshacer. Todos los datos asociados con este usuario serán eliminados permanentemente.' 
                : 'Warning: This action cannot be undone. All data associated with this user will be permanently deleted.'}
            </Typography>
            
            <Box mt={4} display="flex" justifyContent="space-between">
              <Button 
                variant="outlined" 
                color="primary"
                onClick={() => navigate(-1)}
              >
                {language === 'es' ? 'Volver' : 'Go Back'}
              </Button>
              <Button 
                variant="contained" 
                color="error" 
                onClick={handleOpenDialog}
              >
                {language === 'es' ? 'Eliminar Usuario' : 'Delete User'}
              </Button>
            </Box>
            
            <DeleteUser 
              open={openDialog} 
              handleClose={handleCloseDialog} 
            />
          </>
        )}
      </Paper>
    </Container>
  );
};

export default DeleteUserPage;
